// Social card og:image output size, shared between the social-card worker
// (which rasterizes card.png to this width from the 800x400 satori render)
// and the metadata components that declare og:image:width/height.
export const OG_IMAGE_WIDTH = 1200
export const OG_IMAGE_HEIGHT = 600
